<script >
import { ref, defineProps } from '@vue/composition-api';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { default as DropdownTable } from '@/components/dropdownTable';
import { default as FormEditTrailer } from './form/formEditTrailer';
import { default as Alert } from '@/components/alert';
import { useModal } from '@/composable/useModal';
import { trailerService } from '@/api/transport/trailer';
import getMessageError from '@/utils/getMessageError';
import { addingLoading, closeLoading } from '@/utils/handleControlLoading';
import { useUpdateTrailer } from '@/api/transport/trailer/query';
import { toast } from '@/utils/programaticToast';
import { getToastContentComponent } from '@/utils/getToastContentComponent';
const __sfc_main = {};
__sfc_main.props = {
  status: {
    type: Boolean
  },
  row: {
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  /* edit trailer */
  const {
    isOpen: isOpenModalEdit,
    handleVisibility: handleVisibilityModalEdit
  } = useModal();

  /* delete trailer */
  const {
    isOpen: isOpenModalDelete,
    handleVisibility: handleVisibilityModalDelete
  } = useModal();
  const queryClient = useQueryClient();
  async function handleDelete() {
    try {
      addingLoading();
      await trailerService.delete(props.row.id);
      toast.open({
        variant: 'success',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Excluído com sucesso',
          describe: 'Carreta foi excluído com sucesso',
          typeIcon: 'success'
        }),
        closable: true,
        duration: 4000
      });
      queryClient.invalidateQueries({
        queryKey: ['trailers']
      });
      handleVisibilityModalDelete();
    } catch (error) {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Ocorreu um erro',
          describe: getMessageError(error),
          typeIcon: 'error'
        }),
        closable: true,
        duration: 4000
      });
    } finally {
      closeLoading();
    }
  }

  /* restore vehicle */
  const {
    isOpen: isOpenModalRestore,
    handleVisibility: handleVisibilityModalRestore
  } = useModal();
  const {
    mutate: mutateRestore,
    isLoading: isLoadingRestore
  } = useUpdateTrailer();
  function handleRestore() {
    const newTrailer = {
      ...props.row,
      'trailer_is_active': 1
    };
    mutateRestore({
      newTrailer,
      id: props.row.id,
      isFormatedBody: false
    });
  }
  return {
    isOpenModalEdit,
    handleVisibilityModalEdit,
    isOpenModalDelete,
    handleVisibilityModalDelete,
    handleDelete,
    isOpenModalRestore,
    handleVisibilityModalRestore,
    isLoadingRestore,
    handleRestore
  };
};
__sfc_main.components = Object.assign({
  DropdownTable,
  FormEditTrailer,
  Alert
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
  <div>
    <DropdownTable aria-role="list">
      <o-dropdown-item v-show="status" aria-role="listitem" @click="handleVisibilityModalEdit">
        {{ $t('trailer.edit') }}
      </o-dropdown-item>

      <o-dropdown-item v-show="status" aria-role="listitem" @click="handleVisibilityModalDelete">
        {{ $t('trailer.delete') }}
      </o-dropdown-item>

      <o-dropdown-item v-show="!status" aria-role="listitem" @click="handleVisibilityModalRestore">
        {{ $t('trailer.restore') }}
      </o-dropdown-item>
    </DropdownTable>

    <o-modal :active="isOpenModalEdit" width="560" @close="handleVisibilityModalEdit">
      <div>
        <h2 class="header-2">{{ $t('trailer.editTitle') }}</h2>
        <p class="paragraph">{{ $t('trailer.editParagraph') }}</p>
      </div>

      <FormEditTrailer :trailer="row" :close-modal="handleVisibilityModalEdit" />
    </o-modal>

    <Alert
      :active="isOpenModalDelete"
      @handleClose="handleVisibilityModalDelete"
    >
      <template #title> {{ $t('trailer.deleteTitle') }} </template>
      <template #message> {{ $t('trailer.deleteParagraph') }} </template>

      <template #buttons>
        <o-button variant="outline" size="md" @click="handleVisibilityModalDelete"> {{ $t('trailer.buttonCancel') }} </o-button>
        <o-button variant="primary" size="md" @click="handleDelete"> {{ $t('trailer.buttonDelete') }} </o-button>
      </template>
    </Alert>

    <Alert
      :active="isOpenModalRestore"
      @handleClose="handleVisibilityModalRestore"
    >
      <template #title> {{ $t('trailer.restoreTitle') }} </template>
      <template #message> {{ $t('trailer.restoreParagraph') }} </template>

      <template #buttons>
        <o-button variant="outline" size="md" @click="handleVisibilityModalRestore"> {{ $t('trailer.buttonCancel') }} </o-button>
        <o-button variant="primary" size="md" @click="handleRestore"> {{ $t('trailer.buttonRestore') }} </o-button>
      </template>
    </Alert>

    <o-loading :full-page="true" :active.sync="isLoadingRestore" />
  </div>
</template>

